export default {
  client: {
    action: "Import Clients",
    title: "Import Clients",
    mapDescription:
      "Choose the field each of your columns fills. Columns left on Skip are not imported.",
    fieldsGroup: "Client Fields",
    checkingDescription: "Checking every row against the client fields.",
    reviewDescription: "Some rows need attention before they can be imported.",
    dropDescription:
      "Add a CSV file of your clients. Nothing is sent to Invup until you press Import.",
    serverDescription: "Your rows were checked again when you pressed Import.",
    confirmTitle_one: "Import 1 Client",
    confirmTitle_other: "Import {{count, number}} Clients",
    confirmCreates_one: "This creates 1 client in your organization.",
    confirmCreates_other:
      "This creates {{count, number}} clients in your organization.",
    confirmLeftOut_one: "The 1 row with problems is left out.",
    confirmLeftOut_other:
      "The {{count, number}} rows with problems are left out.",
    confirmIrreversible: "An import cannot be undone.",
    successTitle: "Clients imported successfully",
    successBody_one: "1 client was added to your client list.",
    successBody_other:
      "{{count, number}} clients were added to your client list.",
    noneTitle: "No Clients Imported",
    allFailedBody_one: "The 1 row failed, so no clients were added.",
    allFailedBody_other:
      "All {{count, number}} rows failed, so no clients were added.",
    stoppedBody_one:
      "1 of {{total, number}} clients was imported before the import was stopped. It remains in your client list.",
    stoppedBody_other:
      "{{count, number}} of {{total, number}} clients were imported before the import was stopped. They remain in your client list.",
    stoppedBodyNone: "The import was stopped before any clients were imported.",
    failedBody_one:
      "The import stopped because of an error on our end. 1 of {{total, number}} clients was imported before it stopped, and it remains in your client list.",
    failedBody_other:
      "The import stopped because of an error on our end. {{count, number}} of {{total, number}} clients were imported before it stopped, and they remain in your client list.",
    failedBodyNone:
      "The import stopped because of an error on our end, before any clients were imported.",
    failedAdvice:
      "Sorry for the trouble. Check your client list before importing the file again, so the same clients are not added twice.",
    lastDescription: "Your organization’s most recent client import.",
    failuresDescription:
      "These rows were not imported. Fix them in your file, then import them again.",
    unknownBody:
      "The connection dropped before Invup replied, so it is not known whether your import started. Check its status before trying again, so the same clients are not imported twice.",
    progressCloseHint:
      "You can close this window. The import keeps running, and reopening Import Clients shows its progress.",
    runningDescription: "A client import is running for your organization.",
    othersTitle_one: "{{name}} is importing 1 client",
    othersTitle_other: "{{name}} is importing {{count, number}} clients",
    othersTitleAnonymous_one: "Another member is importing 1 client",
    othersTitleAnonymous_other:
      "Another member is importing {{count, number}} clients",
    stopWritten_one:
      "1 of {{total, number}} clients has already been imported.",
    stopWritten_other:
      "{{count, number}} of {{total, number}} clients have already been imported.",
    stopKept:
      "Clients already imported stay in your client list: stopping cannot undo them. The remaining rows are not imported.",
    stopNoneWritten: "No clients have been imported yet.",
    stopNoneKept: "None of its {{total, number}} rows will be imported.",
    blockedLiveBody:
      "{{name}} is importing clients for your organization. You can import your file when theirs finishes.",
    blockedLiveBodyAnonymous:
      "Another member is importing clients for your organization. You can import your file when theirs finishes.",
    blockedUnreadableBody:
      "A client import is already running for your organization. Try again later.",
    importingTitle_one: "Importing 1 client…",
    importingTitle_other: "Importing {{count, number}} clients…",
    viewList: "View Client List",
  },
  project: {
    action: "Import Projects",
    title: "Import Projects",
    mapDescription:
      "Choose the field each of your columns fills. Columns left on Skip are not imported.",
    fieldsGroup: "Project Fields",
    checkingDescription: "Checking every row against the project fields.",
    reviewDescription: "Some rows need attention before they can be imported.",
    dropDescription:
      "Add a CSV file of your projects. Nothing is sent to Invup until you press Import.",
    serverDescription: "Your rows were checked again when you pressed Import.",
    confirmTitle_one: "Import 1 Project",
    confirmTitle_other: "Import {{count, number}} Projects",
    confirmCreates_one: "This creates 1 project in your organization.",
    confirmCreates_other:
      "This creates {{count, number}} projects in your organization.",
    confirmLeftOut_one: "The 1 row with problems is left out.",
    confirmLeftOut_other:
      "The {{count, number}} rows with problems are left out.",
    confirmIrreversible: "An import cannot be undone.",
    successTitle: "Projects imported successfully",
    successBody_one: "1 project was added to your project list.",
    successBody_other:
      "{{count, number}} projects were added to your project list.",
    noneTitle: "No Projects Imported",
    allFailedBody_one: "The 1 row failed, so no projects were added.",
    allFailedBody_other:
      "All {{count, number}} rows failed, so no projects were added.",
    stoppedBody_one:
      "1 of {{total, number}} projects was imported before the import was stopped. It remains in your project list.",
    stoppedBody_other:
      "{{count, number}} of {{total, number}} projects were imported before the import was stopped. They remain in your project list.",
    stoppedBodyNone:
      "The import was stopped before any projects were imported.",
    failedBody_one:
      "The import stopped because of an error on our end. 1 of {{total, number}} projects was imported before it stopped, and it remains in your project list.",
    failedBody_other:
      "The import stopped because of an error on our end. {{count, number}} of {{total, number}} projects were imported before it stopped, and they remain in your project list.",
    failedBodyNone:
      "The import stopped because of an error on our end, before any projects were imported.",
    failedAdvice:
      "Sorry for the trouble. Check your project list before importing the file again, so the same projects are not added twice.",
    lastDescription: "Your organization’s most recent project import.",
    failuresDescription:
      "These rows were not imported. Fix them in your file, then import them again.",
    unknownBody:
      "The connection dropped before Invup replied, so it is not known whether your import started. Check its status before trying again, so the same projects are not imported twice.",
    progressCloseHint:
      "You can close this window. The import keeps running, and reopening Import Projects shows its progress.",
    runningDescription: "A project import is running for your organization.",
    othersTitle_one: "{{name}} is importing 1 project",
    othersTitle_other: "{{name}} is importing {{count, number}} projects",
    othersTitleAnonymous_one: "Another member is importing 1 project",
    othersTitleAnonymous_other:
      "Another member is importing {{count, number}} projects",
    stopWritten_one:
      "1 of {{total, number}} projects has already been imported.",
    stopWritten_other:
      "{{count, number}} of {{total, number}} projects have already been imported.",
    stopKept:
      "Projects already imported stay in your project list: stopping cannot undo them. The remaining rows are not imported.",
    stopNoneWritten: "No projects have been imported yet.",
    stopNoneKept: "None of its {{total, number}} rows will be imported.",
    blockedLiveBody:
      "{{name}} is importing projects for your organization. You can import your file when theirs finishes.",
    blockedLiveBodyAnonymous:
      "Another member is importing projects for your organization. You can import your file when theirs finishes.",
    blockedUnreadableBody:
      "A project import is already running for your organization. Try again later.",
    importingTitle_one: "Importing 1 project…",
    importingTitle_other: "Importing {{count, number}} projects…",
    viewList: "View Project List",
  },
  expense: {
    action: "Import Expenses",
    title: "Import Expenses",
    mapDescription:
      "Choose the field each of your columns fills. Columns left on Skip are not imported.",
    fieldsGroup: "Expense Fields",
    checkingDescription: "Checking every row against the expense fields.",
    reviewDescription: "Some rows need attention before they can be imported.",
    dropDescription:
      "Add a CSV file of your expenses. Nothing is sent to Invup until you press Import.",
    serverDescription: "Your rows were checked again when you pressed Import.",
    confirmTitle_one: "Import 1 Expense",
    confirmTitle_other: "Import {{count, number}} Expenses",
    confirmCreates_one: "This creates 1 expense in your organization.",
    confirmCreates_other:
      "This creates {{count, number}} expenses in your organization.",
    confirmLeftOut_one: "The 1 row with problems is left out.",
    confirmLeftOut_other:
      "The {{count, number}} rows with problems are left out.",
    confirmIrreversible: "An import cannot be undone.",
    successTitle: "Expenses imported successfully",
    successBody_one: "1 expense was added to your expense list.",
    successBody_other:
      "{{count, number}} expenses were added to your expense list.",
    noneTitle: "No Expenses Imported",
    allFailedBody_one: "The 1 row failed, so no expenses were added.",
    allFailedBody_other:
      "All {{count, number}} rows failed, so no expenses were added.",
    stoppedBody_one:
      "1 of {{total, number}} expenses was imported before the import was stopped. It remains in your expense list.",
    stoppedBody_other:
      "{{count, number}} of {{total, number}} expenses were imported before the import was stopped. They remain in your expense list.",
    stoppedBodyNone:
      "The import was stopped before any expenses were imported.",
    failedBody_one:
      "The import stopped because of an error on our end. 1 of {{total, number}} expenses was imported before it stopped, and it remains in your expense list.",
    failedBody_other:
      "The import stopped because of an error on our end. {{count, number}} of {{total, number}} expenses were imported before it stopped, and they remain in your expense list.",
    failedBodyNone:
      "The import stopped because of an error on our end, before any expenses were imported.",
    failedAdvice:
      "Sorry for the trouble. Check your expense list before importing the file again, so the same expenses are not added twice.",
    lastDescription: "The latest expense import.",
    failuresDescription:
      "These rows were not imported. Fix them in your file, then import them again.",
    unknownBody:
      "The connection dropped before Invup replied, so it is not known whether your import started. Check its status before trying again, so the same expenses are not imported twice.",
    progressCloseHint:
      "You can close this window. The import keeps running, and reopening Import Expenses shows its progress.",
    runningDescription: "An expense import is running for your organization.",
    othersTitle_one: "{{name}} is importing 1 expense",
    othersTitle_other: "{{name}} is importing {{count, number}} expenses",
    othersTitleAnonymous_one: "Another member is importing 1 expense",
    othersTitleAnonymous_other:
      "Another member is importing {{count, number}} expenses",
    stopWritten_one:
      "1 of {{total, number}} expenses has already been imported.",
    stopWritten_other:
      "{{count, number}} of {{total, number}} expenses have already been imported.",
    stopKept:
      "Expenses already imported stay in your expense list: stopping cannot undo them. The remaining rows are not imported.",
    stopNoneWritten: "No expenses have been imported yet.",
    stopNoneKept: "None of its {{total, number}} rows will be imported.",
    blockedLiveBody:
      "{{name}} is importing expenses for your organization. You can import your file when theirs finishes.",
    blockedLiveBodyAnonymous:
      "Another member is importing expenses for your organization. You can import your file when theirs finishes.",
    blockedUnreadableBody:
      "An expense import is already running for your organization. Try again later.",
    importingTitle_one: "Importing 1 expense…",
    importingTitle_other: "Importing {{count, number}} expenses…",
    viewList: "View Expense List",
    totalHint: "Blank totals are calculated from subtotal, tax and fees",
  },
  product: {
    action: "Import Products",
    title: "Import Products",
    mapDescription:
      "Choose the field each of your columns fills. Columns left on Skip are not imported.",
    fieldsGroup: "Product Fields",
    checkingDescription: "Checking every row against the product fields.",
    reviewDescription: "Some rows need attention before they can be imported.",
    dropDescription:
      "Add a CSV file of your price list. Nothing is sent to Invup until you press Import.",
    serverDescription: "Your rows were checked again when you pressed Import.",
    confirmTitle_one: "Import 1 Product",
    confirmTitle_other: "Import {{count, number}} Products",
    confirmCreates_one: "This creates 1 product in your catalog.",
    confirmCreates_other:
      "This creates {{count, number}} products in your catalog.",
    confirmLeftOut_one: "The 1 row with problems is left out.",
    confirmLeftOut_other:
      "The {{count, number}} rows with problems are left out.",
    confirmIrreversible: "An import cannot be undone.",
    successTitle: "Products imported successfully",
    successBody_one: "1 product was added to your catalog.",
    successBody_other: "{{count, number}} products were added to your catalog.",
    noneTitle: "No Products Imported",
    allFailedBody_one: "The 1 row failed, so no products were added.",
    allFailedBody_other:
      "All {{count, number}} rows failed, so no products were added.",
    stoppedBody_one:
      "1 of {{total, number}} products was imported before the import was stopped. It remains in your catalog.",
    stoppedBody_other:
      "{{count, number}} of {{total, number}} products were imported before the import was stopped. They remain in your catalog.",
    stoppedBodyNone:
      "The import was stopped before any products were imported.",
    failedBody_one:
      "The import stopped because of an error on our end. 1 of {{total, number}} products was imported before it stopped, and it remains in your catalog.",
    failedBody_other:
      "The import stopped because of an error on our end. {{count, number}} of {{total, number}} products were imported before it stopped, and they remain in your catalog.",
    failedBodyNone:
      "The import stopped because of an error on our end, before any products were imported.",
    failedAdvice:
      "Sorry for the trouble. Check your catalog before importing the file again, so the same products are not added twice.",
    lastDescription: "Your organization’s most recent product import.",
    failuresDescription:
      "These rows were not imported. Fix them in your file, then import them again.",
    unknownBody:
      "The connection dropped before Invup replied, so it is not known whether your import started. Check its status before trying again, so the same products are not imported twice.",
    progressCloseHint:
      "You can close this window. The import keeps running, and reopening Import Products shows its progress.",
    runningDescription: "A product import is running for your organization.",
    othersTitle_one: "{{name}} is importing 1 product",
    othersTitle_other: "{{name}} is importing {{count, number}} products",
    othersTitleAnonymous_one: "Another member is importing 1 product",
    othersTitleAnonymous_other:
      "Another member is importing {{count, number}} products",
    stopWritten_one:
      "1 of {{total, number}} products has already been imported.",
    stopWritten_other:
      "{{count, number}} of {{total, number}} products have already been imported.",
    stopKept:
      "Products already imported stay in your catalog: stopping cannot undo them. The remaining rows are not imported.",
    stopNoneWritten: "No products have been imported yet.",
    stopNoneKept: "None of its {{total, number}} rows will be imported.",
    blockedLiveBody:
      "{{name}} is importing products for your organization. You can import your file when theirs finishes.",
    blockedLiveBodyAnonymous:
      "Another member is importing products for your organization. You can import your file when theirs finishes.",
    blockedUnreadableBody:
      "A product import is already running for your organization. Try again later.",
    importingTitle_one: "Importing 1 product…",
    importingTitle_other: "Importing {{count, number}} products…",
    viewList: "View Catalog",
  },
  map: {
    fileSummary_one: "{{fileName}} · 1 row",
    fileSummary_other: "{{fileName}} · {{count, number}} rows",
    requiredLabel: "Required",
    requiredMapped: "mapped",
    requiredMissing: "not mapped",
    columnsLabel: "Columns:",
    columnCount: "{{imported}} imported · {{skipped}} skipped",
    headers: {
      column: "Your Column",
      mapsTo: "Maps To",
      samples: "Sample Values",
    },
    selectLabel: "Maps to, for column {{column}}",
    skip: "Skip this column",
    requiredOption: "{{label}} (required)",
    usedBy: "Used by {{column}}",
    checkedOnSubmit: "Checked when you press Import",
    noValues: "No values in this column",
    unnamedColumn: "Column {{n}} (no name)",
    blocked: "Map a column to {{fields}} to continue.",
  },
  review: {
    checkingTitle: "Checking {{count, number}} rows…",
    checkingProgress: "{{checked, number}} of {{total, number}} checked",
    changeColumns: "Change Columns",
    summaryTitle_one:
      "{{count, number}} of {{total, number}} rows has problems",
    summaryTitle_other:
      "{{count, number}} of {{total, number}} rows have problems",
    summaryBody_one: "1 row is ready. Nothing has been imported yet.",
    summaryBody_other:
      "{{count, number}} rows are ready. Nothing has been imported yet.",
    allFailTitle: "None of the {{total, number}} rows can be imported",
    allFailBody:
      "Fix the problems in your file, then choose it again. If every row fails the same way, check your column choices.",
    stepper: "Problem row {{index, number}} of {{count, number}}",
    previous: "Previous problem row",
    next: "Next problem row",
    headers: {
      line: "Line",
      field: "Field",
      value: "Value",
      problem: "Problem",
    },
    lineLabel: "Line {{line, number}}",
    rowLabel_one: "Line {{line, number}}, 1 problem",
    rowLabel_other: "Line {{line, number}}, {{count, number}} problems",
    problemLabel: "Line {{line, number}}, column {{field}}: {{reason}}",
    problemLabelRow: "Line {{line, number}}, whole row: {{reason}}",
    emptyValue: "(empty)",
    wholeRow: "Whole row",
    leaveOut_one:
      "Importing now leaves out **1 row with problems** (line {{lines}}). It will not be imported.",
    leaveOut_other:
      "Importing now leaves out **{{count, number}} rows with problems** (lines {{lines}}). They will not be imported.",
    moreLines: "{{lines}} and {{count}} more",
    copyLines: "Copy Line Numbers",
    copied: "Line numbers copied",
    redropConsequence:
      "Choosing a corrected file keeps your column choices if its columns are unchanged. Otherwise you map them again.",
    chooseCorrected: "Choose Corrected File",
    serverTitle: "Invup found problems your browser could not check",
    serverBody_one:
      "1 row was rejected when you pressed Import, so nothing was imported. It is marked “Found on import” below.",
    serverBody_other:
      "{{count, number}} rows were rejected when you pressed Import, so nothing was imported. They are marked “Found on import” below.",
    serverBodyTruncated:
      "At least {{count, number}} rows were rejected when you pressed Import, so nothing was imported. Fix or leave out these rows, then import again to check the rest.",
    foundOnImport: "Found on import",
    reason: {
      required: "{{field}} is required.",
      minLength: "Must be at least {{min, number}} characters.",
      maxLength:
        "Must be {{max, number}} characters or fewer. This value has {{length, number}}.",
      email: "Not a valid email address.",
      countryCode: "Use a two-letter country code, such as CA or US.",
      allowedValues: "This value is not one of the accepted options.",
      decimal:
        "Must be a number with at most {{places, number}} decimal places, such as 12.5.",
      decimalMin: "Must be at least {{min, number}}.",
      decimalMax: "Must be at most {{max, number}}.",
      date: "Must be a date in YYYY-MM-DD format.",
      enumValue: "Must be one of: {{values}}.",
      boolean: "Use yes, no, true, false, 1 or 0.",
      emailList: "Each item must be a valid email address.",
      emailListTooMany: "Use at most {{max, number}} email addresses.",
      currencyCode: "Use a three-letter currency code, such as CAD or USD.",
      requiredIf: '{{field}} is required when {{other}} is "{{value}}".',
      afterOrEqual: "Must be on or after {{other}}.",
      duplicateOf:
        "Duplicate of line {{line, number}}, which uses the same email.",
    },
  },
  steps: {
    ariaLabel: "Import progress",
    file: "Choose File",
    columns: "Map Columns",
    review: "Review Rows",
    import: "Import",
  },
  drop: {
    cleared: "File removed",
    accepts: "Accepts .csv files",
    choose: "Choose a CSV file",
    orDrag: "or drag it here",
    hint: "Up to {{limit, number}} rows. The first row must hold your column names.",
    dragOver: "Drop the file to read it",
    loadingSettings: "Getting import settings…",
    reading: "Reading… {{count, number}} rows so far",
    summary_one: "1 row · {{columns}}",
    summary_other: "{{count, number}} rows · {{columns}}",
    columnCount_one: "1 column",
    columnCount_other: "{{count, number}} columns",
    columnsFound: "Columns found",
    moreColumns: "+{{count, number}} more",
    chooseAnother: "Choose Another File",
    mismatchTitle_one:
      "1 row has a different number of columns than the header row",
    mismatchTitle_other:
      "{{count, number}} rows have a different number of columns than the header row",
    mismatchBody:
      "The first is on line {{line, number}}. This often means values contain unquoted commas, or this is not the file you meant. Missing values will be treated as empty and extra values ignored.",
    refused: {
      notCsv:
        "{{fileName}} is not a CSV file. Save it as CSV (comma-separated values) from your spreadsheet app, then choose it again.",
      empty:
        "{{fileName}} is empty. Choose a file with a row of column names and at least one row under it.",
      headerOnly:
        "{{fileName}} has column names but no rows under them. Add at least one row, then choose it again.",
      overCap:
        "{{fileName}} has {{count, number}} rows, and an import is limited to {{limit, number}}. Split it into smaller files and import each one.",
      unreadable:
        "{{fileName}} could not be read as a CSV file. Check that it was saved as CSV, then choose it again.",
      multiple: "Choose one file at a time.",
    },
  },
  settingsError: {
    title: "Import is unavailable right now",
    body: "Sorry, the import could not be prepared due to an error on our end. Please try again later.",
  },
  submit: {
    keepOpen: "Keep this window open until it finishes.",
    busy: "Importing…",
    serverError:
      "Sorry, your import could not be started due to an error on our end. Please try again.",
  },
  complete: {
    leftOut_one: "1 row you left out was not imported.",
    leftOut_other: "{{count, number}} rows you left out were not imported.",
  },
  open: {
    loading: "Checking for a running import…",
  },
  progress: {
    queuedTitle: "Starting your import…",
    queued: "Waiting for Invup to start the import.",
    processed: "{{processed, number}} of {{total, number}} rows processed",
    failedSoFar_one: "1 row failed so far",
    failedSoFar_other: "{{count, number}} rows failed so far",
    stop: "Stop Import",
    unknownTransient: "Status momentarily unknown. Reconnecting…",
    lostTitle: "Connection lost",
    lostBody:
      "The import keeps running on Invup’s servers. The progress shown is the last Invup reported.",
    checkFailed:
      "Invup could not be reached. Check your connection, then try again.",
    stopUnconfirmed:
      "Invup did not confirm whether the import was stopped. The progress below is current.",
    announce: "{{percent}} processed",
  },
  stop: {
    title: "Stop Import",
    confirm: "Stop Import",
    stopping: "Stopping…",
    startedBySelf: "You started this import.",
    startedBy: "{{name}} started this import.",
    startedByAnonymous: "Another member started this import.",
    error:
      "Sorry, the import could not be stopped due to an error on our end. Please try again.",
    alreadyFinished:
      "This import had already finished, so nothing was stopped.",
  },
  result: {
    meta: "Started {{date}} by {{name}}",
    metaAnonymous: "Started {{date}}",
    stoppedSettling:
      "Rows that were being written when the import was stopped can still be added for a few seconds.",
    announcement: "{{title}}. {{body}}",
    finishedTitle: "Import Finished",
    stoppedTitle: "Import Stopped",
    failedTitle: "Import Failed",
    failedRows_one: "1 row failed and was not imported.",
    failedRows_other: "{{count, number}} rows failed and were not imported.",
  },
  failures: {
    title: "Failed Rows",
    summary_one: "1 row failed",
    summary_other: "{{count, number}} rows failed",
    summaryBody:
      "The download keeps your columns and adds the reason in a last column. Fix the rows, delete that column, then import the file.",
    range: "{{from}} to {{to}} of {{total}}",
    previousPage: "Previous page",
    nextPage: "Next page",
    loading: "Loading failed rows…",
    loadError:
      "Sorry, the failed rows could not be loaded due to an error on our end. Please try again.",
    expiredDescription: "These rows were not imported.",
    expiredTitle: "Failed row details are no longer available",
    expiredBody_one:
      "Invup keeps the details of failed rows for 30 days after an import. The 1 failed row of this import is past that, so it cannot be shown or downloaded.",
    expiredBody_other:
      "Invup keeps the details of failed rows for 30 days after an import. The {{count, number}} failed rows of this import are past that, so they cannot be shown or downloaded.",
    downloading: "Downloading…",
    downloadError:
      "Sorry, the failed rows could not be downloaded due to an error on our end. Please try again later.",
  },
  blocked: {
    title: "Another Import Is Running",
    kept: "Your file and column choices are kept while this window stays open.",
    finishedTitle: "The Other Import Has Finished",
    finishedBody: "You can import your file now.",
  },
  unknown: {
    title: "Import Status Unknown",
    check: "Check Status",
    checking: "Checking…",
    notStartedTitle: "Your import did not start",
    notStartedBody: "Nothing was imported, and your rows are still here.",
    checkFailed:
      "Sorry, the status could not be checked due to an error on our end. Please try again.",
  },
  actions: {
    close: "Close",
    tryAgain: "Try Again",
    cancel: "Cancel",
    continue: "Continue",
    importRows_one: "Import 1 Row",
    importRows_other: "Import {{count, number}} Rows",
    viewFailedRows: "View Failed Rows",
    importAnother: "Import Another File",
    downloadFailedRows: "Download Failed Rows",
    back: "Back",
  },
};
